import React from 'react';
import Navbar from '../../Shared/Navbar/Navbar/Navbar';

const Header = () => {
    return (
        <div>
            <Navbar />
        </div>
    );
};

export default Header;